module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0020.jpg?v=a4029aec";